export default {
	data() {
		return {
			schemaFields: [],
		};
	},
	methods: {
		receiveFieldsFromSchema(schema) {
			if (this.schemaFields.length === 0) {
				this.setSchemaFieldsFromSchema(schema);
			}

			return this.schemaFields;
		},
		setSchemaFieldsFromSchema(schema) {
			if (Array.isArray(schema.children)) {
				schema.children.forEach((c, key) => {
					this.setSchemaFieldsFromSchema(schema.children[key]);
				});
			} else if (Array.isArray(schema)) {
				schema.forEach((c) => {
					if (Array.isArray(c.children)) {
						this.setSchemaFieldsFromSchema(c.children);
					} else {
						this.schemaFields.push(c);
					}
				});
			} else {
				this.schemaFields.push(schema);
			}
		},
	},
};
